<jb-hero-skeleton></jb-hero-skeleton>
<div class="pt4 bg-white min-h-10"></div>
<div class="pt4 bg-white min-h-10"></div>
